const aboutRoute = [
  {
    path: '/about',
    component: () => import('@/views/about/index.vue'),
    redirect: '/about/intro',
    meta:{
      title:'关于瑞谦',
      breadcrumb: true,
      layout: 'DefaultLayout'
    },
    children:[
      {
        path:'intro',
        component: () => import('@/views/about/Intro.vue'),
        meta:{
          title:'公司简介',
          breadcrumb: true,
        }
      },
      {
        path:'culture',
        component: () => import('@/views/about/Culture.vue'),
        meta:{
          title:'企业文化',
          breadcrumb: true,
        }
      },
      {
        path:'honor',
        component: () => import('@/views/about/Honor.vue'),
        meta:{
          title:'企业荣誉',
          breadcrumb: true,
        }
      },
      {
        path:'intoRQ',
        component: () => import('@/views/about/intoRQ/IntoRQ.vue'),
        meta:{ title:'走进瑞谦' }
      }
    ]
  }
]
export default aboutRoute
